module.exports = __webpack_public_path__ + "static/img/bg-login.657f8c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg-login.png
// module id = NIHS
// module chunks = 46